import { fetchPersea } from "@/config/axios/config-axios";
import { GetBenefitAvailableByCampaignBodyType } from "@/types/campaign/benefit-available/benefit-available";


export const getBenefitAvailableByCampaign = async (body: GetBenefitAvailableByCampaignBodyType) => {
  return await fetchPersea(`/campaign/benefit/available`, 'POST', {}, body);
};